<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light">
    <!-- Alert -->
    <div>
      <v-alert :type="alert_type" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Alert End -->
    <!--Title -->
    <header-component :headerTitle="headerText" />
    <!--Title end -->
    <!-- Search -->
    <v-card-title>
      <v-row>
        <v-col cols="2" sm="2">
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" class="search_style" outlined v-on:keyup.enter="loadData(active_tab)"></v-text-field>
        </v-col>
      </v-row>
    </v-card-title>
    <!-- Data table -->
    <v-layout column>
      <v-flex md6 style="overflow: auto">
        <v-data-table
          :dense="true"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          fixed-header
          height="100%" 
          :loading="loading"
          loading-text="Loading Data... Please wait"
          class="elevation-1" >
            <template   #[`item.tag_number`]="{ item }">
              <a @click="itemDetailpopup(item)" style="color: #1976d2;">
                <u> {{ item.tag_number }}</u>
              </a>
            </template>
            <template #[`item.ai_discrepancy`]="{ item }">
              <div v-if="item.ai_grading === null && !item.ai_discrepancy"> N/A </div>
              <div v-else-if="!item.ai_discrepancy" :class="'red-dot'"></div>
              <div v-else-if="item.ai_discrepancy" :class="'green-dot'"></div>
            </template>
            <template #[`item.assisted_grading`]="{item}">
              <span>{{ item.assisted_grading ? item.assisted_grading : "N/A"}}</span>
            </template>
            <template #[`item.ai_grading`]="{item}">
              <span>{{ item.ai_grading ? item.ai_grading : "N/A"}}</span>
            </template>
            <template #[`item.location`]="{item}">
              <span>{{ item.location ? item.location : "N/A"}}</span>
            </template>
          </v-data-table>   
      </v-flex>
    </v-layout>
    <!-- Data table end -->
    <!-- pagination -->
    <div class="float-right">
      <v-row class="ml-2">
        <v-col cols="3" sm="3">
          <v-select v-model="pageSize" :items="pageSizes" label="Items per page" @change="handlePageSizeChange"></v-select>
        </v-col>
        <span class="item-selected"> <span v-if="selected.length == 1">{{selected.length}} Item Selected</span> <span v-if="selected.length > 1">{{selected.length}} Items Selected</span> </span>
        <v-col cols="7" sm="7">
          <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
        </v-col>
      </v-row>
    </div>
    <!-- pagination end -->
  </v-card>
</template>
<script>
  import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
  export default {
    components:{
      HeaderComponent,
    },
    data(){
      return{
        headerText:"AI Discrepancy Report",
        alert: false,
        alert_type:'',
        alert_message:'',
        search_tag:[],
        selected:'',
        table_data:[

        ],
        headers:[
          { text: "Tag Id", align: "start", sortable: false, value:"tag_number"},
          { text: "Assisted Grading", value: "assisted_grading" },
          { text: "AI Grading", value: "ai_grading" },
          { text: "AI Discrepancy", value: "ai_discrepancy" }          
        ],
        search:'',
        loading: true,
        page:1,
        pageSize: 25,
        pageSizes: [25, 50, 75, 100],
        
      }
    },
    created(){
      this.loadData();
      this.scrollToTop();
    },
    methods:{
      loadData(){
        this.loading = true;
        this.selected = []
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.pageSize = 25
        this.headers = [
                          { text: "Tag Id", align: "start", sortable: false, value:"tag_number"},
                          { text: "Assisted Grading", value: "assisted_grading" },
                          { text: "AI Grading", value: "ai_grading" },
                          { text: "AI Discrepancy", value: "ai_discrepancy" },
                          { text: "Location", value: "location" }
                        ]; 
        this.getdata();
      },
      getdata(){
        const params = this.getRequestParams(this.page, this.pageSize);
        this.$http.secured
          .get('/api/v1/inventory_grading_details',{ params: { page: params['page'], per_page: params['size'], query: this.search_tag} } )
          .then(response => {
            if (response.data) {
            this.table_data = response.data.inventory_grading_details;
            this.totalPages = response.data.meta.total_pages
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert(error, this.response.data.error);
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      },
      itemDetailpopup(item){
        this.$http.secured
        .get(`/api/v1/inventory_grading_details/${item.id}`)
        .then((response) => {
          if (response.data) {
            this.ai_discrepancy_data = response.data.ai_discrepancy_data;
            if(this.ai_discrepancy_data === null || (Array.isArray(this.ai_discrepancy_data) && this.ai_discrepancy_data.length === 0)){
              this.showAlert("warning", "Data not available");
            }else{
                this.$store.commit("setLotIds", {
                lotIds: item.id,
                action:item.tag_number,
                });    
                this.$router.push({ name: "Itemdetails"});
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });        
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },
      // pagination script
      handlePageSizeChange(size) {
          this.pageSize = size;
          this.page = 1
          this.getdata();
      },
      handlePageChange(value) {
        this.page = value;
        this.getdata();
      },
      getRequestParams(page, pageSize) {
        let params = {};

        if (page) {
          params["page"] = page;
        }
        if (pageSize) {
          params["size"] = pageSize;
        }
        return params;
      },
    }
  }
</script>
<style>
  .item-selected{
        margin-top: 23px;
        position: absolute;
        left: 41%;
    }
    .green-dot {
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
  }

  .red-dot {
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/components/api/v1/Aireports/aireports.vue